export interface Response<T> {
  state: State;
  message: string;
  body?: T;
  errors?: any;
}

export enum State {
  ERROR,
  SUCCESS
}

class FetchError extends Error {
  private data: any | null;

  constructor(m: string, data?: any) {
    super(m);

    this.data = data;

    // Set the prototype explicitly.
    Object.setPrototypeOf(this, FetchError.prototype);
  }

  getData(): any | null {
    return this.data;
  }
}

export class HTTP {
  private controller: AbortController | null = null;

  private constructor() {
  }

  public static instance(): HTTP {
    return new HTTP();
  }

  public async fetchJSON<T>(url: string, params?: RequestInit): Promise<Response<T>> {
    try {
      this.controller = new AbortController();

      if (params) {
        params.signal = this.controller.signal;
      } else {
        params = { signal: this.controller.signal }
      }

      const resp = await fetch(url, params);
      const json = await resp.json();

      if (resp.status != 200) {
        throw new Error(resp.statusText);
      }

      if (json.error == true) {
        throw new FetchError(
          json.message ? json.message : 'Unknown server error',
          json.errors
        );
      }

      return { state: State.SUCCESS, message: 'ok', body: json };
    } catch (e) {
      if (e instanceof FetchError) {
        return { state: State.ERROR, message: e.message, errors: e.getData() };
      }

      return { state: State.ERROR, message: e.message };
    }
  }

  public abortFetchJSON(): void {
    this.controller?.abort();
  }
}